import React from 'react';
import {useAuth} from "../../../helpers/AuthContext";
import Form from "../../Form";
import CouponForm from "./CouponForm";
import Modal from "../../Modal";
import EditCouponForm from "./EditCouponForm";
import CreateCouponForm from "./CreateCouponForm";

function CreateCouponModal({
                             onSuccess,
                             onError,
                             onClose
                         }) {
    return (
        <Modal
            isOpen={true}
            title={`Create a Coupon`}
            onClose={onClose}
        >
            <CreateCouponForm
                onSuccess={() => {
                    if (onSuccess) {
                        onSuccess();
                    }
                }}
                onError={(error) => {
                    if (onError) {
                        onError(error);
                    }
                }}
            />
        </Modal>
    );
}

export default CreateCouponModal;